"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HostViewComponentPropsFactory = void 0;
const asset_key_generator_1 = require("../../asset_key_generator");
const GameplayComponentPropsFactory_1 = require("./GameplayComponentPropsFactory");
const types_1 = require("../../gameplay/types");
class HostViewComponentPropsFactory extends GameplayComponentPropsFactory_1.GameplayComponentPropsFactory {
    createQuestionBottomProps() {
        var _a;
        if (this.card.cardQuestion.questionText) {
            const props = {
                text: this.card.cardQuestion.questionText,
                className: 'questionText-text',
                gameplayStyle: this.style,
            };
            return props;
        }
        else if (this.card.cardQuestion.image) {
            const assetKey = asset_key_generator_1.AssetKeyGenerator.key(this.card.cardQuestion.image, asset_key_generator_1.AssetType.Image);
            const url = (_a = this.fileUrls.get(assetKey)) !== null && _a !== void 0 ? _a : '';
            const props = {
                src: url,
                imageName: this.card.cardQuestion.image,
                disabled: false,
                className: 'questionBottom-image',
                gameplayStyle: this.style,
            };
            return props;
        }
        return undefined;
    }
    createQuestionChoiceProps() {
        if (this.card.cardQuestion.textChoices.length > 0) {
            const answerChoices = this.card.cardQuestion.textChoices;
            const answerChoiceStats = answerChoices.map(choice => ({ playerCount: 0, choice }));
            const props = {
                choiceStats: answerChoiceStats,
                correctAnswer: this.card.cardAnswer.answerTexts[0],
                className: 'questionChoice-bars',
                gameplayStyle: this.style,
                gameplayControl: types_1.GameplayControl.PresentQuestion,
            };
            return props;
        }
        else if (this.card.cardQuestion.imageChoices.length > 0) {
            const answerChoices = this.card.cardQuestion.imageChoices;
            const answerChoiceStats = answerChoices.map(choice => ({
                choice: choice,
                playerCount: 0,
                imageUrl: this.fileUrls.get(asset_key_generator_1.AssetKeyGenerator.key(choice, asset_key_generator_1.AssetType.Image)),
            }));
            const props = {
                choiceStats: answerChoiceStats,
                correctAnswer: this.card.cardAnswer.answerTexts[0],
                className: 'questionChoice-bars',
                gameplayStyle: this.style,
                gameplayControl: types_1.GameplayControl.PresentQuestion,
            };
            return props;
        }
        else {
            const props = {
                choiceStats: [
                    { choice: 'Correct', playerCount: 0 },
                    { choice: 'Incorrect', playerCount: 0 },
                ],
                correctAnswer: 'Correct',
                className: 'questionChoice-bars',
                gameplayStyle: this.style,
                gameplayControl: types_1.GameplayControl.PresentQuestion,
            };
            return props;
        }
    }
}
exports.HostViewComponentPropsFactory = HostViewComponentPropsFactory;
